import { BiLogOutCircle, BiUserCircle } from "react-icons/bi";
import { VscLaw } from "react-icons/vsc";

export const items = [
  {
    name: "Minha conta",
    className: "ant-typography",
    icon: <BiUserCircle color="var(--ant-primary-color)" />,
  },
  {
    name: "Regulação",
    className: "ant-typography",
    icon: <VscLaw color="var(--ant-primary-color)" />,
  },
  {
    name: "Sair",
    className: "ant-typography logout",
    icon: <BiLogOutCircle color="var(--ant-error-color)" />,
  },
];
